import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { queryClient } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';
import { QUERIES } from 'constants/index';

export function useAddLinkMutation() {
  const { t } = useTranslation();

  const { mutateAsync: addLinkMutation, isLoading } = useMutation(
    API_HANDLERS.QUICK_LINKS.ADD_LINK_FROM_PRESET,
    {
      onSuccess: () => {
        alert.success(t('toasts.quickLinks.success.add'));
        queryClient.invalidateQueries([QUERIES.QUICK_LINKS_LIST]);
      },
    },
  );

  return { isLoading, addLinkMutation };
}
